import debugLog from "@/composables/debugLog";
const parseFieldsToSearchUrl = (fields) => {
  if (
    !fields.loc ||
    !fields.loc.dist ||
    !fields.loc.coords ||
    !fields.umkreis
  ) {
    return false;
  }
  const queryParams = {};
  const directParams = ["zb", "bf", "S", "fs", "ptv", "pta", "pts"];
  directParams.forEach((v) => {
    if (fields[v] && fields[v][0]) queryParams[v] = fields[v][0];
  });

  // Fachrichtungen
  if (fields.fach) {
    if (fields.fach[0]) queryParams['g'] = fields.fach[0];
    if (fields.fach[1]) queryParams['fg'] = fields.fach[1];
  }

  // Time Fields
  if (fields.spDatum) {
    queryParams['spDatum'] = new Date(fields.spDatum)
          .toLocaleDateString("en-UK")
          .replaceAll("/", ".")
  }

  if (fields.spVon) {
    queryParams['spVon'] = new Date(fields.spVon).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        })
  }

  if (fields.spBis) {
    queryParams['spBis'] =
        new Date(fields.spBis).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        })
  }
  
  if (fields.nachname) {
    queryParams["n"] =fields.nachname.toLowerCase();
  }

  // Distance
  const distance = parseFloat(fields.loc.dist + parseFloat(fields.umkreis[0]));
  const lon = fields.loc.coords.split(",")[0];
  const lat = fields.loc.coords.split(",")[1];
  queryParams['dist'] = parseFloat(fields.loc.dist + parseFloat(fields.umkreis[0]));
  queryParams['lon'] = fields.loc.coords.split(",")[0];
  queryParams['lat'] = fields.loc.coords.split(",")[1];
  queryParams['token'] = token;


  const urlCall = siteRoot + "typo3conf/ext/arztsuchevue/Classes/Controller/callUrl.php";
  const pdfCall = window.location.href + "?" + encodeURI("tx_arztsuchevue_connector[controller]=Connector&tx_arztsuchevue_connector[action]=returnPdf&tx_web2pdf_pi1[action]=&tx_web2pdf_pi1[argument]=printPage&tx_web2pdf_pi1[controller]=Pdf&no_cache=1");
  
  // debugLog(queryParams);
  // debugLog(urlCall);

  return  {urlCall, pdfCall, queryParams};
};

function replaceUmlauts(string)
{
    let value = string.toLowerCase();
    value = value.replace(/ä/g, '*');
    value = value.replace(/ö/g, '*');
    value = value.replace(/ü/g, '*');
    value = value.replace(/ß/g, '*');
    return value;
}

export default parseFieldsToSearchUrl;
